<success *ngIf="success" class="mt-3">
  <p i18n="@@broker.priceAlertModal.successfullyDeactivated">Your alert has been deactivated successfully</p>
  <button class="btn btn-primary btn-block w-100" (click)="onFinish()" i18n="@@broker.priceAlertModal.closeButton">Close</button>
</success>

<div *ngIf="!success" class="content">
  <div *ngIf="error" class="alert alert-warning">
    {{error}}
  </div>

  <div class="section row">
    <div class="field-wrap">
      <div class="key text-primary col-5" i18n="@@broker.priceAlertModal.price">Price</div>
      <div class="d-flex flex-column text-start">
        <div *ngIf="useGlobalCurrency" class="text-bold">{{globalCurrency}} {{(price || 0) | number:'1.2-2'}}</div>
        <div *ngIf="!useGlobalCurrency"class="text-bold">{{baseCurrency}} {{(price || 0) | number:'1.2-8'}}</div>
      </div>
    </div>
  </div>

  <div class="section row">
    <div class="field-wrap">
      <div class="key text-gray col-5" i18n="@@broker.priceAlertModal.below">Below</div>
      <div class="d-flex flex-column text-start">
        <div *ngIf="useGlobalCurrency" class="text-bold">{{globalCurrency}} {{((priceAlert?.minPrice.amount || 0) * globalCurrencyRate) | number:'1.2-2'}}</div>
        <div *ngIf="!useGlobalCurrency" class="text-bold">{{baseCurrency}} {{(priceAlert?.minPrice.amount || 0) | number:'1.2-8'}}</div>
      </div>
    </div>
  </div>

  <div class="section row">
    <div class="field-wrap">
      <div class="key text-gray col-5" i18n="@@broker.priceAlertModal.above">Above</div>
      <div class="d-flex flex-column text-start">
        <div *ngIf="useGlobalCurrency" class="text-bold">{{globalCurrency}} {{((priceAlert?.maxPrice?.amount || 0) * globalCurrencyRate) | number:'1.2-2'}}</div>
        <div *ngIf="!useGlobalCurrency" class="text-bold">{{baseCurrency}} {{(priceAlert?.maxPrice?.amount || 0) | number:'1.2-8'}}</div>
      </div>
    </div>
  </div>

  <div class="section row">
    <div class="field-wrap align-items-center pe-none">
      <div class="key text-gray col-4" i18n="@@broker.priceAlertModal.notificationType">Notify By</div>
      <div class="val text-center col-8 justify-content-around">
        <div class="align-items-center d-flex">
          <mat-checkbox id="sms" [checked]="hasType(PriceAlertType.SMS)" i18n="@@broker.priceAlertModal.sms">SMS</mat-checkbox>
        </div>
        <div class="align-items-center d-flex">
          <mat-checkbox id="email" [checked]="hasType(PriceAlertType.EMAIL)" i18n="@@broker.priceAlertModal.email">EMAIL</mat-checkbox>
        </div>
      </div>
    </div>
  </div>

  <div class="p-2"></div>
  <div class="btns row">
    <div class="col-6">
      <button class="btn btn-danger btn-block" (click)="onSave()" [disabled]="loading">
        <ng-container *ngIf="loading" i18n="@@broker.priceAlertModal.submitLoading">Loading...</ng-container>
        <ng-container *ngIf="!loading" i18n="@@broker.priceAlertModal.deactivateButton">Deactivate</ng-container>
      </button>
    </div>
    <div class="col-6">

<button class="btn btn-block btn-light" (click)="onCancel()" i18n="@@broker.priceAlertModal.cancelButton">Cancel</button>
    </div>
  </div>
</div>
